import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { UtilService } from 'src/app/services/util.service';

@Component({
  selector: 'app-kyc-details',
  templateUrl: './kyc-details.component.html',
  styleUrls: ['./kyc-details.component.scss']
})
export class KycDetailsComponent {
  get loanDetails(){
    return this.util.loanDetails;
  }
  get currentApplicant(){
    return this.util.getCurrentApplicant;
  }
  get isMoratorium():boolean{
    return this.util.loanDetails && (this.util.loanDetails.hasMoratorium || this.util.loanDetails.isCapacitaFlow) && !(!this.util.loanDetails.isStudentMainApplicant && !this.util.loanDetails.isSponser);
  }
  switchTabEvent:Subject<any> = new Subject();
  constructor(private router: Router, private util:UtilService){

  }
  ngOnInit() {
   
  }

  switchTab(isMainApplicant: boolean) {
    const app = this.util.getCache('currentApplicant');
    this.util.setCache('currentApplicant', this.util.loanDetails.loanApplicantDetails?.find((app: any) => app.mainApplicant === isMainApplicant)?.id);
    
    this.switchTabEvent.next(app !== this.util.getCache('currentApplicant'));
  }
}
